(() => {
  document.querySelectorAll('video[autoplay]').forEach((video) => {
    video.addEventListener('play', (event) => event.stopImmediatePropagation());
    let visible = false;
    video.addEventListener('pause', () => {
      if (visible) video.play().catch(() => {});
    });
    new IntersectionObserver(([entry]) => {
      visible = entry.isIntersecting;
      if (visible) video.play().catch(() => {});
      else video.pause();
    }).observe(video);
  });
})();
